<template>
  <div id="app">
    <router-view />
    <backUp></backUp>
  </div>
</template>

<script>
import backUp from './components/backup'
export default {
  components: { backUp },
  name: 'App'
}
</script>
